import { combineReducers } from '@reduxjs/toolkit';
import submitApplyPromoCodeSlice from './promoCodeSlice';

export default combineReducers({
    promocode: submitApplyPromoCodeSlice,
});
